import { FC } from 'react';
import { CodeEditor, DescriptionBlock } from '../../../../../../common/components';
import { PageComponent } from '../../../../entities';
import { Button, Popconfirm, Space, theme } from 'antd';
import { Link } from 'react-router-dom';
import { AppRoutes } from '../../../../../../common/interfaces';
import { ExclamationCircle, PencilSquare, Trash } from 'react-bootstrap-icons';
import { CommonDrawerTitle } from '../../../../../../common/layouts';

interface Props {
  component: PageComponent;
  disableControlButtons: boolean;
  isDeleteComponentLoading: boolean;
  handleDeleteComponent: () => void;
}

export const PageComponentsViewView: FC<Props> = ({
  component,
  disableControlButtons,
  isDeleteComponentLoading,
  handleDeleteComponent
}) => {
  const { token } = theme.useToken();

  return (
    <>
      <CommonDrawerTitle
        onlyExtra
        extra={
          <Space>
            <Link to={ AppRoutes.PageComponentsByIdEdit.replace(':siteId', component.site.id).replace(':componentId', component.id) }>
              <Button type="default" icon={ <PencilSquare/> } disabled={ disableControlButtons }>
                Редагувати
              </Button>
            </Link>
            <Popconfirm
              destroyTooltipOnHide
              title="Видалити компонент"
              icon={ <ExclamationCircle color={ token.colorError }/> }
              description="Ви дійсно хочете видалити цей компонент?"
              onConfirm={ handleDeleteComponent }
              okText="Так, видалити"
              okButtonProps={{ danger: true }}
              cancelText="Ні"
              placement="left"
              disabled={ disableControlButtons }
            >
              <Button
                type="primary"
                danger
                icon={ <Trash/> }
                disabled={ disableControlButtons }
                loading={ isDeleteComponentLoading }
              >
                Видалити
              </Button>
            </Popconfirm>
          </Space>
        }
      />

      <DescriptionBlock items={ [['Назва', component.name]] }/>

      <DescriptionBlock
        items={ [['Вміст', <CodeEditor key={ 'component.content' } value={ component.content } disableMinimap readOnly height={ 600 }/>]] }
      />
    </>
  );
};
